/**
 * PushInvitacion — tarjeta que pide activar los avisos del SOA en este dispositivo. Es obligatoria para todo el equipo (decisión del 24-oct): los espacios de trabajo, el chat
 * y las tareas avisan por acá, no por Google Chat; sin el aviso activado la gente se entera tarde de lo que le toca.
 * Aparece si el dispositivo lo soporta y todavía no hay una suscripción. «Más tarde» la oculta unas horas (vuelve a aparecer); si el navegador la tiene bloqueada,
 * explica cómo habilitarla. No aparece en el modo prueba de dirección (para no tapar la barra violeta).
 */
import { useEffect, useState } from "react";
import { estadoPush, activarPush } from "../lib/pushStaff.js";
import { useToast } from "./Toast.jsx";

const CLAVE = "crew_push_invitacion_hasta";
const HORAS_DE_PAUSA = 4;

export default function PushInvitacion() {
  const { toast } = useToast();
  const [modo, setModo] = useState(null);   // 'activar' | 'bloqueado'
  const [ocupado, setOcupado] = useState(false);

  useEffect(() => {
    let vivo = true;
    (async () => {
      try { if (Number(localStorage.getItem(CLAVE) || 0) > Date.now()) return; } catch { /* sin storage */ }
      if (typeof Notification === "undefined") return;
      if (Notification.permission === "denied") { if (vivo) setModo("bloqueado"); return; }
      if (Notification.permission !== "default") return;
      if ((await estadoPush()) === "inactivo" && vivo) setModo("activar");
    })();
    return () => { vivo = false; };
  }, []);

  if (!modo) return null;
  const masTarde = () => { try { localStorage.setItem(CLAVE, String(Date.now() + HORAS_DE_PAUSA * 3600 * 1000)); } catch { /* sin storage */ } setModo(null); };
  const activar = async () => {
    setOcupado(true);
    try { await activarPush(); toast.success("Notificaciones activadas"); setModo(null); }
    catch (e) { toast.error(e.message || "No se pudo activar"); if (typeof Notification !== "undefined" && Notification.permission === "denied") setModo("bloqueado"); }
    setOcupado(false);
  };

  return (
    <div role="region" aria-label="Activar notificaciones"
         className="mx-4 mt-2 flex items-center gap-2 rounded-3xl bg-card px-3 py-2 shadow-[0_1px_3px_rgba(17,19,24,0.06)] sm:gap-3 sm:px-4 sm:py-3 lg:mx-6">
      <span className="msr text-[22px] text-[#0E7490]" aria-hidden="true">notifications</span>
      {modo === "activar" ? (
        <>
          <p className="min-w-0 flex-1 text-[13px] font-semibold leading-tight text-foreground sm:text-[14px]">
            <span className="sm:hidden">Activá los avisos: es obligatorio</span>
            <span className="hidden sm:inline">Activá los avisos en este dispositivo: es obligatorio para todo el equipo. Así te enterás de lo que te toca (tareas, menciones, espacios y pedidos) sin depender de Google Chat.</span>
          </p>
          <div className="flex flex-shrink-0 gap-1 sm:gap-2">
            <button onClick={activar} disabled={ocupado} className="h-9 rounded-full bg-foreground px-3 text-[13px] font-extrabold text-background disabled:opacity-60 sm:h-10 sm:px-4 sm:text-[14px]">Activar</button>
            <button onClick={masTarde} className="h-9 rounded-full px-2 text-[13px] font-bold text-muted-foreground sm:h-10 sm:px-3 sm:text-[14px]">Más tarde</button>
          </div>
        </>
      ) : (
        <>
          <p className="min-w-0 flex-1 text-[13px] font-semibold leading-tight text-foreground sm:text-[14px]">Los avisos están bloqueados en este navegador. Habilitalos desde el candado de la barra de direcciones (Notificaciones → Permitir) y recargá la página.</p>
          <button onClick={masTarde} className="h-9 flex-shrink-0 rounded-full px-3 text-[13px] font-bold text-muted-foreground sm:h-10 sm:text-[14px]">Entendido</button>
        </>
      )}
    </div>
  );
}
